import { calculateIMC, classifyBP, classifyGlucose } from "@/pages/FormF1/helpers";

// ── Radar normalization (each dimension 0-100) ───────────

export function normalizeRadarData(profile, flags) {
  const { hasF1, hasF2, hasF3, hasF4, hasF5 } = flags;
  const data = [];

  if (hasF1) {
    const scores = [];
    const imc = calculateIMC(profile.peso, profile.talla);
    if (imc) scores.push(normalizeIMC(imc));
    const bp = normalizeBP(profile.paSistolica, profile.paDiastolica);
    if (bp !== null) scores.push(bp);
    const glu = normalizeGlucose(profile.glucemia);
    if (glu !== null) scores.push(glu);
    const avg = scores.length > 0 ? Math.round(scores.reduce((a, b) => a + b, 0) / scores.length) : 0;
    data.push({ dimension: "Clínico", value: avg, color: "#00628F" });
  }

  if (hasF2) {
    const map = { Excelente: 100, Bueno: 75, Normal: 50, Promedio: 50, Bajo: 25 };
    const scores = [
      map[profile.f2Results.clasificacion6mwt],
      map[profile.f2Results.clasificacionSentadillas],
      map[profile.f2Results.clasificacionFlexiones],
      map[profile.f2Results.clasificacionFlexibilidad],
    ].filter((s) => s !== undefined);
    const avg = scores.length > 0 ? Math.round(scores.reduce((a, b) => a + b, 0) / scores.length) : 0;
    data.push({ dimension: "Físico", value: avg, color: "#00628F" });
  }

  if (hasF3) {
    const score = { high: 100, moderate: 60, low: 20 }[profile.f3Results.clasificacionIPAQ] ?? 0;
    data.push({ dimension: "Actividad", value: score, color: "#F9A01B" });
  }

  if (hasF4) {
    const score = Math.round((profile.f4Results.scoreCalidadDieta / 40) * 100);
    data.push({ dimension: "Nutrición", value: Math.min(100, score), color: "#157346" });
  }

  if (hasF5) {
    const emotionalVal = typeof profile.f5Results?.scoreGlobal === "number"
      ? profile.f5Results.scoreGlobal
      : 0;
    data.push({ dimension: "Emocional", value: emotionalVal, color: "#883476" });
  }

  return data;
}

function normalizeIMC(imc) {
  const v = parseFloat(imc);
  if (v >= 18.5 && v < 25) return 100;
  if (v >= 25 && v < 30) return 60;
  if (v >= 30) return 30;
  return 60;
}

function normalizeBP(sys, dia) {
  if (!sys || !dia) return null;
  const s = parseFloat(sys), d = parseFloat(dia);
  if (isNaN(s) || isNaN(d)) return null;
  if (s < 120 && d < 80) return 100;
  if (s < 130) return 70;
  if (s < 140 || d < 90) return 40;
  return 10;
}

function normalizeGlucose(glu) {
  if (!glu) return null;
  const v = parseFloat(glu);
  if (isNaN(v)) return null;
  if (v < 100) return 100;
  if (v < 126) return 50;
  return 10;
}

// ── Diet color/label ─────────────────────────────────────

export function getDietColor(cat) {
  return { poor: "#C0453A", fair: "#F9A01B", good: "#157346", excellent: "#157346" }[cat] || "#F9A01B";
}

export function getDietLabel(cat) {
  return { poor: "Deficiente", fair: "Mejorable", good: "Buena", excellent: "Excelente" }[cat] || cat;
}

// ── Emotional color/label ────────────────────────────────

export function getEmotionalColor(score) {
  if (score <= 25) return "#C0453A";
  if (score <= 45) return "#C0453A";
  if (score <= 65) return "#F9A01B";
  if (score <= 80) return "#157346";
  return "#157346";
}

export function getEmotionalLabel(score) {
  if (score <= 25) return "Crítico";
  if (score <= 45) return "Bajo";
  if (score <= 65) return "Moderado";
  if (score <= 80) return "Bueno";
  return "Excelente";
}
